import React, { useState } from 'react';
import { PlusOutlined, DeleteOutlined, EyeOutlined } from '@ant-design/icons';
import { Image, Space, Button } from 'antd';
import PropTypes from 'prop-types';
import ModalEditImagesList from './ModalEditImagesList';
import constants from '../../../../config/api/constants';
import { ButtonUpload, ContentActionsImg } from '../../style';
import { useDictionaryTranslation } from '../../../../hooks/useDictionaryTranslation';
import { useNotifications } from '../../../../hooks/useNotifications';

export const ImgListComponent = ({ field, value, onChange, parents, disabledField, showAction = true }) => {
  const [previewVisible, setPreviewVisible] = useState(false);
  const [currentImages, setCurrentImages] = useState(value ?? []);
  const [showModal, setShowModal] = useState(false);

  const { showConfirmNotification } = useNotifications();
  const { translate: t } = useDictionaryTranslation();

  const handleDeleteImage = (imageToDelete) => {
    showConfirmNotification({
      title: t('areYouSure'),
      content: t('thisRecordWillBeRemoved'),
      onOk: () => {
        const updatedImages = currentImages.filter((img) => img !== imageToDelete);
        setCurrentImages(updatedImages);
        onChange(updatedImages);
      },
    });
  };

  const handlePreview = () => {
    setPreviewVisible(true);
  };

  const onCloseModal = async ({ imgList }) => {
    try {
      if (imgList != null) {
        setCurrentImages(imgList);
        await onChange(imgList);
      }
    } catch (error) {
      console.error('Error updating image list:', error);
    }
    setShowModal(false);
  };

  const getFilePath = (img) => (typeof img === 'string' ? `${constants.s3UrlPath}/${img}` : img?.fileUrl);

  return (
    <>
      <Space wrap>
        {currentImages.map((img, index) => (
          <div
            key={index}
            style={{
              position: 'relative',
              display: 'flex',
              margin: '5px',
              width: 110,
              height: 140,
              overflow: 'hidden',
              alignItems: 'center',
              justifyContent: 'center',
              border: 'solid 1px #cccccc',
            }}
          >
            <Image src={getFilePath(img)} style={{ borderRadius: '5px' }} preview={false} />
            <ContentActionsImg>
              <Button
                type="default"
                className="btnPreview"
                icon={<EyeOutlined />}
                size="small"
                onClick={handlePreview}
              />
              <Button
                className="btnDelete"
                type="primary"
                danger
                icon={<DeleteOutlined />}
                size="small"
                onClick={() => handleDeleteImage(img)}
                disabled={disabledField}
              />
            </ContentActionsImg>
          </div>
        ))}
        {showAction ? (
          <ButtonUpload
            disabled={field.limit <= currentImages?.length || disabledField}
            onClick={() => setShowModal(true)}
            icon={<PlusOutlined />}
          />
        ) : null}
      </Space>

      {previewVisible && (
        <Image.PreviewGroup
          preview={{
            visible: previewVisible,
            onVisibleChange: (vis) => setPreviewVisible(vis),
          }}
        >
          {currentImages.map((img) => (
            <Image key={img} src={getFilePath(img)} />
          ))}
        </Image.PreviewGroup>
      )}

      {showModal ? (
        <ModalEditImagesList
          onCloseModal={onCloseModal}
          field={field}
          value={value}
          parents={parents}
          show={showModal}
        />
      ) : null}
    </>
  );
};

ImgListComponent.propTypes = {
  field: PropTypes.shape({
    idInput: PropTypes.string,
    limit: PropTypes.number,
  }),
  value: PropTypes.array,
  onChange: PropTypes.func,
  parents: PropTypes.array,
  disabledField: PropTypes.bool,
  showAction: PropTypes.bool,
};
